/**
 * Converts a boolean string value `value` into a boolean. If passed
 * something other than 'true' or 'false' will coerce value to boolean.
 *
 * @param {*} value - a value of any type
 * @returns {boolean} - that value as a boolean
 */
export const coerceToBoolean = (value: unknown): boolean => {
  if (value === 'true' || value === 'false') {
    return value === 'true';
  }
  return Boolean(value);
};
